import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import SuiBox from "components/sui/SuiBox";
import SuiTypography from "components/sui/SuiTypography";
import SuiButton from "components/sui/SuiButton";

import CdxInput from "components/cdx/CdxInput";

import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import signInWithEmailLink from "app/fb/signInWithEmailLink";

import { LSK_EMAIL_FOR_VERIFICATION } from "settings/localStorageKeys";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BASE_APP_PATH } from "settings/routes";

const VerifyEmailForm = ({ email, isSignIn }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const validateForm = (values) => {
    const error = {};

    if (!values.email) {
      error.email = "Please enter email";
    } else {
      const validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
      };
      if (!validateEmail(values.email)) {
        error.email = "Please enter a valid email";
      }
    }

    return error;
  };

  const onSubmit = async (values) => {
    const error = {};
    const result = await signInWithEmailLink(values.email, isSignIn);
    const redirect_to = searchParams.get("redirect_to") || BASE_APP_PATH;
    if (result.type === "success") {
      navigate(redirect_to);
    } else if (result.type === "error") {
      if (isSignIn) {
        navigate(redirect_to);
      }
      if (result.data.code === "auth/invalid-email") {
        error.email = "Invalid email";
      } else if (result.data.code === "auth/invalid-action-code") {
        error[FORM_ERROR] =
          "Invalid sign in code, please make another sign in request.";
      } else {
        error[FORM_ERROR] = "Unable to sign in, please try again";
      }
    }
    return error;
  };

  useEffect(() => {
    if (email) {
      onSubmit({ email: email });
    }
  }, [email]);

  return (
    <Form
      onSubmit={onSubmit}
      validate={validateForm}
      render={({ handleSubmit, form, submitError, submitting, pristine }) => {
        const formState = form.getState();
        return (
          <SuiBox
            component="form"
            role="form"
            width="100%"
            onSubmit={handleSubmit}
          >
            <Field
              name="email"
              initialValue={
                email || window.localStorage.getItem(LSK_EMAIL_FOR_VERIFICATION)
              }
            >
              {({ input, meta }) => (
                <CdxInput
                  name={input.name}
                  value={input.value}
                  onChange={input.onChange}
                  onBlur={input.onBlur}
                  mb={2}
                  label={t("Email")}
                  disabled={!!email}
                  error={
                    !!(meta.error && meta.touched) ||
                    !!meta.submitError ||
                    !!submitError
                  }
                  message={
                    ((meta.error && meta.touched) || meta.submitError) &&
                    (t(meta.error) || t(meta.submitError))
                  }
                />
              )}
            </Field>
            {submitError && (
              <SuiBox>
                <SuiTypography color="error" variant="caption">
                  {t(submitError)}
                </SuiTypography>
              </SuiBox>
            )}
            <SuiBox mt={3}>
              <SuiButton
                variant="gradient"
                color="info"
                type="submit"
                fullWidth
                disabled={
                  submitting || Object.values(formState.errors).length > 0
                }
              >
                {t("Confirm your email")}
              </SuiButton>
            </SuiBox>
          </SuiBox>
        );
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return { email: state.user.email, isSignIn: state.app.isSignIn };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailForm);
